import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  UrlTree,
} from '@angular/router';
import { Injectable } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { Store } from '@ngrx/store';
import { TokenDto } from '../shared/models/franchise/franchise.model';
import { selectAuthenticatedUser, selectVisibleMenuIds } from '../store/user/user.selectors';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private store: Store<{ user: TokenDto }>,
    private router: Router
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    router: RouterStateSnapshot
  ):
    | boolean
    | UrlTree
    | Promise<boolean | UrlTree>
    | Observable<boolean | UrlTree> {
    // Get the menuId for the current route
    const requiredMenuId = route.data['menuId'];

    return combineLatest([
      this.store.select(selectAuthenticatedUser),
      this.store.select(selectVisibleMenuIds),
    ]).pipe(
      take(1),
      map(([isUserAuth, visibleMenuIds]) => {
        if (!isUserAuth) {
          // If the user is not authenticated, redirect to the login page
          return this.router.createUrlTree(['/auth']);
        }

        // If the user is authenticated but does not have access to the menuId, redirect to home
        if (requiredMenuId != null && !visibleMenuIds?.includes(requiredMenuId)) {
          return this.router.createUrlTree(['/home']);
        }

        // Allow access if authenticated and menuId is valid (or not required)
        return true;
      })
    );
  }
}
